import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { ProjectService } from './project.service';

/** My Own Space: a drive surface with no backing Project entity (STUDIO-1998). */
const MY_SPACE_URL: RegExp = /^\/my-space(\/|$|\?)/;

/**
 * Single source of truth for "are we on a drive-backed surface?".
 *
 * There are three surfaces, not two: a drive-mode project, My Own Space (drive-backed but with no
 * Project entity), and a legacy project. Callers that flag requests as drive (`drive:true` on the
 * signature body, `?drive=true` on participants) must send the flag for the first two and withhold
 * it for the third — the backend fails a drive-flagged entity fast with INVALID_PARAMETER when it
 * cannot resolve an owning project, and legacy entities have none.
 */
@Injectable({ providedIn: 'root' })
export class DriveSurfaceService {
  private readonly projectService = inject(ProjectService);
  private readonly router = inject(Router);

  /**
   * My Own Space is checked first: it has no loaded project, and a project left over from an
   * earlier navigation must not decide the answer for it.
   */
  public isDriveSurface(): boolean {
    if (MY_SPACE_URL.test(this.router.url)) {
      return true;
    }
    return this.projectService.project?.mode === 'drive';
  }
}
